import { makeAutoObservable, runInAction } from "mobx";
import RootStore from "../../../stores/RootStore";

export default class ScheduleGeneratorFormStore {
    // Observables
    isLoading = false;
    error: string | null = null;
    formData: any = {};
    isValid = false;

    // Constructor
    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    // Actions
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    setError(error: string | null) {
        this.error = error;
    }

    setFormData(data: any) {
        this.formData = { ...this.formData, ...data };
        this.validateForm();
    }

    validateForm() {
        // Simple validation logic
        this.isValid = Object.keys(this.formData).length > 0;
    }

    // Async actions
    async save() {
        try {
            this.setLoading(true);
            this.setError(null);

            // Mock save operation
            console.log("Saving form data:", this.formData);

            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 1000));

        } catch (error: any) {
            runInAction(() => {
                this.setError(error.message || "Failed to save form");
            });
            console.error("Failed to save form:", error);
        } finally {
            this.setLoading(false);
        }
    }

    reset() {
        this.formData = {};
        this.isValid = false;
        this.error = null;
    }
}
